import { call, put, takeLatest } from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import actions from 'react/api/actions';

const {
  resequenceHistory: {
    actions: {
      requestResequenceHistory,
      requestResequenceHistorySuccess,
    }
  }
} = actions;

export function* api(action) {
  const { url } = action.payload;
  return yield call(defaultFetch, url);
}

export function* requestResequenceHistorySaga(action){
  const { routeId } = action.payload;
  const response = yield call(api, action)
  const { error } = response;
  if(!error){
    const successPayload = { response, routeId };
    yield put({ type: requestResequenceHistorySuccess, successPayload })
  }
}

export default function* resequenceHistory(){
  yield takeLatest(requestResequenceHistory, requestResequenceHistorySaga);
}
